{
  "flags": {
    "pt-br": {
      "icon": "🇧🇷",
      "name": "Português"
    },
    "es-mx": {
      "icon": "🇲🇽",
      "name": "Español"
    },
    "en-us": {
      "icon": "🇺🇸",
      "name": "English"
    }
  }
}
